import { useCallback } from 'react';

import { UseSetRolesReturn, SetRolesParams } from './useSetRoles.decl';

import {
  AssignRolesToUserMutation,
  AssignRolesToUserMutationVariables,
} from '@generated/AssignRolesToUserMutation';
import { ASSIGN_ROLES_TO_USER_MUTATION } from '@graphql/mutations/AssignRolesToUserMutation';
import { useGraphMutationWithFeedback } from '@hooks/useMutation';

export function useSetRoles(): UseSetRolesReturn {
  const [mutate, { loading }] = useGraphMutationWithFeedback<
    AssignRolesToUserMutation,
    AssignRolesToUserMutationVariables
  >(ASSIGN_ROLES_TO_USER_MUTATION, {
    type: 'form',
  });

  const setRoles = useCallback(
    async ({ userId, roles }: SetRolesParams) => {
      const { error } = await mutate({
        variables: {
          input: {
            userId,
            roleIds: roles.map(({ ID }) => ID),
          },
        },
        update(cache) {
          cache.modify({
            id: cache.identify({ __typename: 'AgentV2', ID: userId }),
            fields: {
              roles: () => roles,
            },
          });
        },
      });

      return error;
    },
    [mutate]
  );

  return { setRoles, loading };
}
